import * as FileSaver from 'file-saver';
import ExcelJS, { Workbook, Worksheet } from 'exceljs';
import {
  defaultCellStyle,
  styles,
  rowStyle,
  BOLD_FONT,
  PER_FMT_LIST,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
/**
 * 将给定的工作簿写入 XLSX 文件并下载。
 *
 * @param workbook - 要写入的工作簿对象。
 * @param fileName - 下载文件的名称，包括扩展名。
 *
 * @returns {Promise<void>} - 一个 Promise，表示写入和下载操作的完成状态。
 *
 * @throws {Error} - 如果写入或下载过程中发生错误，将会抛出异常。
*/
const writeXLSX = async (workbook: any, fileName: string) => {
  const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';
  try {
    const data = await workbook.xlsx.writeBuffer();
    const blob = new Blob([data], { type: EXCEL_TYPE });
    FileSaver.saveAs(blob, fileName);
    // setStatus('success');
  } catch {
    // setStatus('error');
  }
};

const setDownloadDataPlus = (sheet: Worksheet, data: string[], rowStyles?: any) => {
  if (data.length === 0) {
    return;
  }
  // 第一行一定是表头
  sheet.addRow(data[0]).eachCell({ includeEmpty: false }, (cell: any) => {
    Object.assign(cell, rowStyle);
  });
  data.slice(1).forEach((e) => {
    sheet.addRow(e).eachCell({ includeEmpty: false }, (cell: any) => {
      Object.assign(cell, rowStyles);
    });
  });
};

const setDownloadDataWithSummaryStyle = (sheet: Worksheet, data: string[]) => {
  if (data.length === 0) {
    return;
  }
  // 第一行一定是表头
  sheet.addRow(data[0]).eachCell({ includeEmpty: false }, (cell: any) => {
    Object.assign(cell, { font: BOLD_FONT });
  });
  if (data.length > 1) {
    sheet.addRows(data.slice(1));
  }
};

const setDownloadDataWithFirstColBold = (sheet: Worksheet, data: string[]) => {
  if (data.length === 0) {
    return;
  }
  // 第一行一定是表头
  for (let i = 0; i < data.length; i++) {
    var j = 0;
    sheet.addRow(data[i]).eachCell({ includeEmpty: false }, (cell: any) => {
      if (j++ == 0) {
        Object.assign(cell, { font: BOLD_FONT });
      }
    });
  }
};


const setDownloadDataWithNoneStyle = (sheet: Worksheet, data: string[]) => {
  if (data.length === 0) {
    return;
  }
  // 第一行一定是表头
  sheet.addRows(data);
};

const defaultRowNumFmt = (sheet: Worksheet) => {
  sheet.getRow(1).eachCell((cell, colNumber) => {
    const { value } = cell;
    if (PER_FMT_LIST?.includes(value)) {
      // eslint-disable-next-line no-param-reassign
      sheet.getColumn(colNumber).numFmt = '0.00%';
    }
  });
};

/**
 * 将工作簿写入指定的文件格式。
 *
 * @param workbook - 要写入的工作簿对象。
 * @param fileName - 输出文件的名称。
 *
 * @returns {Promise<void>} - 一个表示写入操作完成的 Promise。
 *
 * @throws {Error} - 如果写入操作失败，将抛出错误。
 *
 * @remarks
 * 根据当前参数的文件格式，函数将选择写入 XLSX 或 CSV 格式。
 */
export const writeFile = async (sheets: any, fileName: string = '') => {
  const workbook = new ExcelJS.Workbook();
  // eslint-disable-next-line no-restricted-syntax
  for (const sheetName in sheets) {
    const sheet = workbook.addWorksheet(sheets[sheetName].sheetName || sheetName);
    const newList = sheets[sheetName].data || [];
    // 先在这里处理一下样式
    if (sheets[sheetName].style == 'normal') {
      setDownloadDataPlus(sheet, newList, defaultCellStyle);
    } else if (sheets[sheetName].style == 'summary') {
      setDownloadDataWithSummaryStyle(sheet, newList);
    } else if (sheets[sheetName].style == 'first col bold') {
      setDownloadDataWithFirstColBold(sheet, newList);
    } else {
      setDownloadDataWithNoneStyle(sheet, newList);
    }
    defaultRowNumFmt(sheet);
  }
  await writeXLSX(workbook, fileName);
};